import { convertToObjById } from "../../../helpers/convertToObject";
import { notesTypes } from "./notesTypes";

const {
  SET_NOTES_FILTERS,
  CLEAR_NOTES,
  GET_NOTES,
  SET_CONFIG_FILTER_NOTES,
  SET_CONFIG_PAGE_NOTES,
  SET_CONFIG_PAGE_SIZE_NOTES,
  SET_CONFIG_SORTED_NOTES,
} = notesTypes;

const INITIAL_STATE = {
  notes: {},
  startDate: new Date(),
  endDate: new Date(),
  station: [],
  units: [],
  config: {
    pageSize: 10,
    page: 0,
    sorted: [],
    filtered: [],
  },
};

export const notesReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case SET_NOTES_FILTERS:
      return {
        ...state,
        [payload.key]: payload.data,
      };

    case CLEAR_NOTES:
      return {
        ...state,
        ...INITIAL_STATE,
      };

    case GET_NOTES: {
      const listNotes = convertToObjById(payload);
      return {
        ...state,
        notes: listNotes,
      };
    }

    case SET_CONFIG_FILTER_NOTES:
      return {
        ...state,
        config: {
          ...state.config,
          filtered: payload,
          page: 0,
        },
      };

    case SET_CONFIG_PAGE_NOTES:
      return {
        ...state,
        config: {
          ...state.config,
          page: payload,
        },
      };

    case SET_CONFIG_PAGE_SIZE_NOTES:
      return {
        ...state,
        config: {
          ...state.config,
          pageSize: payload,
          page: 0,
        },
      };

    case SET_CONFIG_SORTED_NOTES:
      return {
        ...state,
        config: {
          ...state.config,
          sorted: payload,
          page: 0,
        },
      };

    default:
      return state;
  }
};
